import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarEmpreendimentoByIdService } from "../../../services/buscarEmpreendimentoByIdService";

export const useBuscarEmpreendimentoById = (
  empreendId: number | undefined | null,
  fetch: boolean
) => {
  const [empreendimento, setEmpreendimento] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as empreendimento
  useEffect(() => {
    const fetchLead = async () => {
      if (empreendId && fetch) {
        setIsLoading(true);
        try {
          const data = await buscarEmpreendimentoByIdService(empreendId);
          if (data) {
            setEmpreendimento(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar empreendimento:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchLead();
  }, [empreendId, fetch]);

  return { empreendimento, isLoading };
};
